import React, { useEffect, useState, useReducer } from 'react';
import { academicProgramsService } from 'services';
import { buildProgramDetailsViewModel } from './program-details/viewModel';
import { ProgramHeaderCard } from './program-details/ProgramHeaderCard';
import { ProgramDetailsCard } from './program-details/ProgramDetailsCard';
import { ProgramClassificationsCard } from './program-details/ProgramClassificationsCard';
import { ProgramLocationsCard } from './program-details/ProgramLocationsCard';
import { ProgramDescriptionCard } from './program-details/ProgramDescriptionCard';
import { RequestHistoryCommentsCard } from './program-details/RequestHistoryCommentsCard';
import { EnrollmentHistoryCard } from './program-details/EnrollmentHistoryCard';

export const AcademicAffairProgramView = ({ academicAffairsData }) => {
    const [cips, setCips] = useState([]);
    const [extraDetailsHasLoaded, setExtraDetailsHasLoaded] = useState(false);
    const [extraViewDetails, setExtraViewDetails] = useReducer(
        (state, newState) => ({ ...state, ...newState }),
        {}
    );

    useEffect(() => {
        academicProgramsService
            .getSixCips()
            .then(setCips)
            .catch(() => {});
    }, []);

    useEffect(() => {
        const programId = academicAffairsData?.programDetails?.programId;
        if (!programId) return;
        academicProgramsService
            .getProgramExtraViewDetails(programId)
            .then(details => {
                setExtraViewDetails(details ?? {});
                setExtraDetailsHasLoaded(details != null);
            })
            .catch(() => {});
    }, [academicAffairsData]);

    const viewModel = buildProgramDetailsViewModel(
        academicAffairsData,
        cips,
        extraViewDetails,
        extraDetailsHasLoaded
    );

    if (!viewModel) return null;

    return (
        <div className="page-container">
            <div className="container-fluid">
                <ProgramHeaderCard {...viewModel.header} />
                <div className="row">
                    <div className="col-md-4">
                        <ProgramDetailsCard {...viewModel.details} />
                    </div>
                    <div className="col-md-4">
                        <ProgramClassificationsCard {...viewModel.classifications} />
                    </div>
                    <div className="col-md-4">
                        <ProgramLocationsCard {...viewModel.locations} />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-6">
                        <ProgramDescriptionCard {...viewModel.description} />
                    </div>
                    <div className="col-md-6">
                        <RequestHistoryCommentsCard {...viewModel.requestHistory} />
                    </div>
                </div>
                <div className="mt-3">
                    <EnrollmentHistoryCard {...viewModel.enrollment} />
                </div>
            </div>
        </div>
    );
};
